export const TitleHeaderFallback = () => {
    return <div id="content-name"><div className="skeleton"/></div>
}